const TempMin = -20
const TempMax = 45

export const getTemperaturePercentage = (temp: number) =>
    ((temp - TempMin) / (TempMax - TempMin)) * 100
